import { useQuery } from "@tanstack/react-query";
import { Fuel } from "lucide-react";
import { api, getPrices } from "@/lib/api";
import { useFeeCurrency, formatFee, FeeToggle } from "@/hooks/useFeeCurrency";

// Typical gas used on FSC (measured with eth_estimateGas); approve adds ~46k on first USDT trade
export const GAS_UNITS = { sell: 124000, swapFmi: 69000, swapUsdt: 75000, approve: 46000 };

const getGasPrice = () =>
  api.post("/rpc", { jsonrpc: "2.0", id: 1, method: "eth_gasPrice", params: [] }).then((r) => parseInt(r.data.result, 16));

export const GasHint = ({ gasUnits, note, testId = "gas-hint" }) => {
  const { currency, toggle } = useFeeCurrency();
  const { data: gasPrice } = useQuery({ queryKey: ["gasPrice"], queryFn: getGasPrice, refetchInterval: 30000 });
  const { data: prices } = useQuery({ queryKey: ["exchangePrices"], queryFn: getPrices, staleTime: 60000 });
  if (!gasPrice) return null;
  const fmi = (gasPrice * gasUnits) / 1e18;
  return (
    <div data-testid={testId} className="flex flex-wrap items-center justify-center gap-x-1.5 gap-y-1 text-[11px] text-zinc-500 text-center">
      <Fuel size={12} className="text-[#D4AF37] shrink-0" />
      <span className="whitespace-nowrap">Network fee ≈ <span data-testid={`${testId}-value`} className="font-mono text-zinc-300">{formatFee(fmi, prices?.FMI?.usd, currency)}</span></span>
      <FeeToggle currency={currency} onToggle={toggle} testId={`${testId}-toggle`} />
      {note && <span className="whitespace-nowrap">· {note}</span>}
    </div>
  );
};
